import angular from "angular"

export default angular.module("directives.availabilitybutton", []).component("availabilitybutton", {
  template: require("./availabilitybutton.html"),
  bindings: {
    onToggleCheck: "&",
    isPending: "<",
  },
}).name
